module.exports = __webpack_public_path__ + "static/media/image_2.87d1d16a.png";